import React, { useEffect, useState } from 'react';
import css from './AdminPageFlipAndWin.css';
import AdminHOC from '../AdminPanelsPage/AdminHOC';
import routeConfiguration from '../../routeConfiguration';
import AdminActionsNav from '../AdminPanelsPage/AdminActionsNav';
import EditForm from './EditForm';
import OfferBlock from '../LandingPage/sectionsForClubs/SectionOurPartners/OfferBlock';
import { createResourceLocatorString } from '../../util/routes';
import { useRequest } from '../../hooks/useRequest';
import { getFlipAndWinCards } from '../../util/api';
import { Alert, IconSpinner } from '../../components';

const Panel = ({
    showList,
    handleAdminAction,
    handleSubmit,
    goBack,
    showForm,
    initialValues,
    action,
    history,
}) => {
    const [cards, setCards] = useState([]);
    const { error, loading, request } = useRequest();

    const requestCards = async () => await request(getFlipAndWinCards, setCards);

    useEffect(() => {
        requestCards();
    }, []);

    if (loading) {
        return <IconSpinner />;
    }

    if (error) {
        return <Alert showAsPlainText type="failure" description={error} closeAllowed={false} />;
    }

    return (
        <>
            <AdminActionsNav
                handleAdding={() => handleAdminAction('add')}
                handleWatchList={() =>
                    history.push(createResourceLocatorString('FlipAndWin', routeConfiguration()))
                }
            />
            {showForm && (
                <p type="button" onClick={goBack} className={css.backButton}>
                    Go back
                </p>
            )}
            {showList && (
                <div className={css.offersHolder}>
                    {cards.map((entry, index) => (
                        <OfferBlock
                            key={index}
                            {...entry}
                            threeLinesHeight={84}
                            handleAdminAction={action => handleAdminAction(action, entry)}
                        />
                    ))}
                </div>
            )}
            {showForm && (
                <EditForm onSubmit={handleSubmit} initialValues={initialValues} action={action} />
            )}
        </>
    );
};

export default AdminHOC(Panel);
